const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};

export const trackPageView = () => fbq("track", "PageView");
export const trackLead = () => fbq("track", "Lead");
export const trackInitiateCheckout = () => fbq("track", "InitiateCheckout");
export const trackPurchase = (value, currency = "USD") =>
  fbq("track", "Purchase", { value, currency });
